module.exports = __webpack_public_path__ + "img/003.bcbf3b6c.png";